import axios from 'axios';
import { auth } from './firebase';

function normalizeBase(base) {
  if (!base) return 'http://localhost:4001/api';
  const trimmed = base.replace(/\/+$/, '');
  return trimmed.endsWith('/api') ? trimmed : `${trimmed}/api`;
}

const api = axios.create({
  baseURL: normalizeBase(import.meta.env.VITE_API_BASE),
});

api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
